window.Sq = window.Sq || {};
Sq.Tracking = Sq.Tracking || {};

Sq.Tracking.cdp = Sq.Tracking.cdp || {
  // allow no-op Sq.Tracking.cdp.track calls if tracking disabled
  track() {},
};
